
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Form, Select, SelectOption, SelectProps } from 'tdesign-react';

import { IFormItemProps } from '@/components';
import { fetchCAIModelList, fetchVENUSModelList } from '@/services/bot';

import styles from './index.module.less';


interface IFormArrayProps {
  fieldsConfig: IFormItemProps[];
  form: any;
  repeatConfig?: {
    [key: string]: IFormItemProps[];
  };
}

const { FormItem } = Form;

export const CustomModelSelect: React.FC<
{
  fieldname: string;
  config: any;
  errors: { [key: string]: any };
  getFieldDecorator: any;
  value: { modelId: undefined, modelType: 1 | 2 };
  max: number;
  onChange: (value: { modelId: string | undefined, modelType: 1 | 2 }) => {};
  disabled?: boolean;
} & IFormArrayProps
> = (props) => {
  const {
    value = { modelId: undefined, modelType: 1 },
    onChange,
    disabled = false,
  } = props;

  const [form] = Form.useForm();

  const [options1, setOptions1] = useState<{ value: string, label: string }[]>([]);
  const [options2, setOptions2] = useState<{ value: string, label: string }[]>([]);

  const options = useMemo(() => (value.modelType === 1 ? options1 : options2), [options1, options2, value]);

  const loadCAIModels = useCallback(async () => {
    const res = await fetchCAIModelList();
    if (res) {
      setOptions1(res.map(item => ({ label: item.name, value: item.id.toString() })));
    }
  }, []);

  const loadVENUSModels = useCallback(async () => {
    const res = await fetchVENUSModelList();
    if (res) {
      setOptions2(res.map(item => ({ label: item.name, value: item.id.toString() })));
    }
  }, []);

  const filterMethod: SelectProps['filter'] = useCallback((
    search: any,
    option: SelectOption,
  ) => option.label.includes(`${search}`), []);

  const handleValuesChange = useCallback((e: any) => {
    if ('modelType' in e) {
      onChange({ ...value, ...e, modelId: undefined });
      form.setFieldsValue({ ...value, ...e, modelId: undefined });
    } else {
      onChange({ ...value, ...e });
    }
  }, [value]);

  useEffect(() => {
    loadCAIModels();
    loadVENUSModels();
  }, []);

  return (
    <Form form={form} initialData={value} className={styles.arrayWrap} onValuesChange={handleValuesChange}>
      <FormItem name='modelType' className={styles.item} labelAlign='top' label='模型来源'>
        <Select options={[{ value: 1, label: 'CAI' }, { value: 2, label: 'VENUS' }]}>
        </Select>
      </FormItem>
      <FormItem name='modelId' className={styles.item} labelAlign='top' label='模型'>
        <Select
          disabled={disabled}
          options={options}
          value={value.modelId}
          filter={filterMethod}
        />
      </FormItem>
    </Form>
  );
};
